import React from 'react';
import { AutocompleteInput, BooleanInput, Edit, ReferenceInput, required, SimpleForm, TextInput } from 'react-admin';
import { ROOT_LEVEL } from '../../../config/constants';
import ConditionalImageUploader from './ConditionalImageUploader';

const ProblemEdit = ({ level, ...otherProps }) => (
  <Edit title="Edit Problem" undoable={false} {...otherProps}>
    <SimpleForm>
      <TextInput label="Name" source="name" />
      <ReferenceInput
        source="article_id"
        label="Article"
        reference={`admin/knowledge-bank/articles/autocomplete`}
        perPage={10000}
        allowEmpty
        emptyValue={null}
      >
        <AutocompleteInput />
      </ReferenceInput>

      <TextInput label="Level" source="level" disabled defaultValue={level} />
      {level !== ROOT_LEVEL && (
        <ReferenceInput
          source="parent_id"
          reference={`admin/problems/${level}/problems/autocomplete`}
          perPage={10000}
          validate={required()}
        >
          <AutocompleteInput />
        </ReferenceInput>
      )}

      <ConditionalImageUploader label="Image" imageInputSource="image" />
      <BooleanInput label="Start chat" source="should_start_chat" />
    </SimpleForm>
  </Edit>
);

export default ProblemEdit;
